module.exports = __webpack_public_path__ + "img/logo31.38f0475c.jpg";